import React from 'react';
import { SiteSection, SiteSectionHeader } from '../../components/site';
import type { SolutionPremiumSections } from './types';
import { useTabPanel } from './useTabPanel';

const PILLAR_THEMES: Record<string, string> = {
  guest: 'guest',
  energy: 'energy',
  ops: 'ops',
};

export const SolutionHospitalityPlatform: React.FC<{
  pillars: SolutionPremiumSections['pillars'];
}> = ({ pillars }) => {
  const { active, getPanelProps, getTabProps } = useTabPanel(pillars.items);

  return (
    <SiteSection id="pillars" tone="muted" className="hosp-platform">
      <SiteSectionHeader
        eyebrow={pillars.eyebrow}
        title={pillars.title}
        subtitle={pillars.subtitle}
        align="center"
      />
      <div className="hosp-platform__layout">
        <div className="hosp-platform__nav" role="tablist" aria-label="Platform pillars">
          {pillars.items.map((pillar) => {
            const selected = pillar.id === active.id;
            return (
              <button
                key={pillar.id}
                type="button"
                className={`hosp-platform__nav-btn${selected ? ' hosp-platform__nav-btn--active' : ''}`}
                {...getTabProps(pillar, selected)}
              >
                {pillar.label}
              </button>
            );
          })}
        </div>
        {pillars.items.map((pillar) => {
          const theme = PILLAR_THEMES[pillar.id] ?? 'guest';
          return (
            <div
              key={pillar.id}
              className={`hosp-platform__panel${pillar.id === active.id ? ' hosp-platform__panel--active' : ''}`}
              {...getPanelProps(pillar)}
            >
              <article className={`hosp-platform__stage hosp-platform__stage--${theme}`}>
                <div className="hosp-platform__art" aria-hidden>
                  <img
                    src={pillar.image.src}
                    alt=""
                    width={pillar.image.width}
                    height={pillar.image.height}
                    loading="lazy"
                  />
                </div>
                <div className="hosp-platform__body">
                  <span className="hosp-platform__pill">{pillar.label}</span>
                  <h3 className="hosp-platform__title">{pillar.title}</h3>
                  <ul className="hosp-platform__items">
                    {pillar.items.map((item) => (
                      <li key={item.title} className="hosp-platform__item">
                        <h4>
                          <span className="hosp-platform__dot" aria-hidden />
                          {item.title}
                        </h4>
                        <p>{item.description}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </div>
          );
        })}
      </div>
    </SiteSection>
  );
};
